<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.5 10.2961C21.5 13.3337 19.0376 15.7961 16 15.7961C12.9624 15.7961 10.5 13.3337 10.5 10.2961C10.5 7.25856 12.9624 4.79613 16 4.79613C19.0376 4.79613 21.5 7.25856 21.5 10.2961ZM19.5 10.2961C19.5 12.2291 17.933 13.7961 16 13.7961C14.067 13.7961 12.5 12.2291 12.5 10.2961C12.5 8.36313 14.067 6.79613 16 6.79613C17.933 6.79613 19.5 8.36313 19.5 10.2961Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25 25.7961V24.5188C25 21.2051 22.3137 18.5188 19 18.5188H13C9.68629 18.5188 7 21.2051 7 24.5188V24.7961C7 25.9007 7.89543 26.7961 9 26.7961H24C24.2652 26.7961 24.5196 26.6908 24.7071 26.5032C24.8946 26.3157 25 26.0613 25 25.7961ZM23 24.5188V24.7961H9V24.5188C9 22.3096 10.7909 20.5188 13 20.5188H19C21.2091 20.5188 23 22.3096 23 24.5188Z"
        />
    </svg>
</template>
